module.exports = __webpack_public_path__ + "img/glentana-house.429b3c52.jpg";